import React, { createContext, useContext } from 'react'

import { useRecipeGridCustomisationData } from './ContentBlocks/useRecipeGridCustomisationData'

type RecipeGridCustomisationContextValue = ReturnType<typeof useRecipeGridCustomisationData>

const RecipeGridCustomisationContext = createContext<
  RecipeGridCustomisationContextValue | undefined
>(undefined)

type RecipeGridCustomisationProviderProps = React.PropsWithChildren<{
  collectionId?: string
  menuId: string
}>

export const RecipeGridCustomisationProvider = ({
  children,
  collectionId,
  menuId,
}: RecipeGridCustomisationProviderProps) => {
  const value = useRecipeGridCustomisationData({ collectionId, menuId })

  return (
    <RecipeGridCustomisationContext.Provider value={value}>
      {children}
    </RecipeGridCustomisationContext.Provider>
  )
}

export const useRecipeGridCustomisation = () => {
  const context = useContext(RecipeGridCustomisationContext)

  if (!context) {
    throw new Error(
      'useRecipeGridCustomisation must be used within RecipeGridCustomisationProvider',
    )
  }

  return context
}
